import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ArrowShrinkSvg = function ArrowShrinkSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.447 9.47 2 3.022 3.022 2 9.47 8.447v-4.58h1.445v7.049H3.867V9.47zM20.133 13.084h-7.049v7.05h1.446v-4.581L20.978 22 22 20.978l-6.447-6.448h4.58zM13.084 3.867h1.446v4.58L20.978 2 22 3.022 15.553 9.47h4.58v1.445h-7.049zM9.47 15.553 3.022 22 2 20.978l6.447-6.448h-4.58v-1.446h7.049v7.05H9.47z"
  }));
};
export var ArrowShrink = function ArrowShrink(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ArrowShrinkSvg
  }));
};